import ExcelJS from 'exceljs/dist/exceljs.min.js';

const MIN_COLUMN_WIDTH = 15;

export const createWorkbook = () => new ExcelJS.Workbook();

export const rowsToSheet = (workbook, sheetName, columns, rows) => {
  const worksheet = workbook.addWorksheet(sheetName);

  worksheet.columns = (columns || []).map((header) => ({
    header,
    key: header,
    width: Math.max(String(header || '').length + 2, MIN_COLUMN_WIDTH)
  }));

  (rows || []).forEach((row) => {
    worksheet.addRow(row);
  });

  return worksheet;
};

export const downloadWorkbook = async (workbook, filename) => {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([
    buffer
  ], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const objectUrlApi = window.URL || window.webkitURL;
  const objectUrl = objectUrlApi.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  objectUrlApi.revokeObjectURL(objectUrl);
};

export const readWorkbookFromFile = async (file) => {
  const workbook = createWorkbook();
  const buffer = await file.arrayBuffer();
  await workbook.xlsx.load(buffer);
  return workbook;
};